import { Link } from "react-router-dom";

const MOVIE_SHORTCUTS = [
  { label: "动作片", genre: "动作", icon: "ri-sword-line" },
  { label: "喜剧片", genre: "喜剧", icon: "ri-emotion-happy-line" },
  { label: "科幻片", genre: "科幻", icon: "ri-planet-line" },
  { label: "悬疑片", genre: "悬疑", icon: "ri-question-mark" },
];

const TV_SHORTCUTS = [
  { label: "古装剧", genre: "古装", icon: "ri-ancient-gate-line" },
  { label: "犯罪剧", genre: "犯罪", icon: "ri-shield-star-line" },
  { label: "家庭剧", genre: "家庭", icon: "ri-home-heart-line" },
  { label: "历史剧", genre: "历史", icon: "ri-book-2-line" },
];

function ShortcutItem({
  label,
  to,
  icon,
  tone,
}: {
  label: string;
  to: string;
  icon: string;
  tone: "secondary" | "accent";
}) {
  const toneClass =
    tone === "secondary"
      ? "bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50"
      : "bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-primary-950";
  return (
    <Link
      to={to}
      className="group flex flex-col items-center gap-2 rounded-lg border border-background-200 bg-background-50 p-3 transition-all hover:-translate-y-1 hover:border-primary-300"
    >
      <span className={`flex h-11 w-11 items-center justify-center rounded-full transition-colors ${toneClass}`}>
        <i className={`${icon} text-xl`} />
      </span>
      <span className="text-sm font-medium text-foreground-800">{label}</span>
    </Link>
  );
}

export default function CategoryShortcuts() {
  return (
    <section className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-center gap-2 border-b-2 border-background-200 pb-2.5">
        <span className="flex h-6 w-6 items-center justify-center rounded-md bg-secondary-500 text-background-50">
          <i className="ri-apps-2-line text-sm" />
        </span>
        <h2 className="font-heading text-lg font-bold text-foreground-900">分类快捷入口</h2>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <Link
            to="/movie"
            className="mb-3 flex items-center justify-between rounded-lg bg-primary-600 px-4 py-2.5 text-background-50 transition-colors hover:bg-primary-700"
          >
            <span className="flex items-center gap-2 font-heading text-sm font-semibold">
              <i className="ri-movie-2-line" />
              电影频道
            </span>
            <i className="ri-arrow-right-s-line" />
          </Link>
          <div className="grid grid-cols-4 gap-2">
            {MOVIE_SHORTCUTS.map((item) => (
              <ShortcutItem
                key={item.genre}
                label={item.label}
                icon={item.icon}
                tone="secondary"
                to={`/movie?genre=${encodeURIComponent(item.genre)}`}
              />
            ))}
          </div>
        </div>

        <div>
          <Link
            to="/tv"
            className="mb-3 flex items-center justify-between rounded-lg bg-secondary-600 px-4 py-2.5 text-background-50 transition-colors hover:bg-secondary-700"
          >
            <span className="flex items-center gap-2 font-heading text-sm font-semibold">
              <i className="ri-tv-2-line" />
              电视剧频道
            </span>
            <i className="ri-arrow-right-s-line" />
          </Link>
          <div className="grid grid-cols-4 gap-2">
            {TV_SHORTCUTS.map((item) => (
              <ShortcutItem
                key={item.genre}
                label={item.label}
                icon={item.icon}
                tone="accent"
                to={`/tv?genre=${encodeURIComponent(item.genre)}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}